<template>
  <div class="drugControlModel">
    <div class="my-map-box">
      <MyMap ref="mapRef" />
    </div>
    <div class="selectarea" :class="{ more: showMore }">
      <el-form :inline="true" ref="formRef" :model="tableParams" class="form-inline">
        <div class="formDiv">
          <el-select v-model="tableParams.libraryIds" placeholder="请选择" style="width: 130px;" @change="changeLibraryIds">
            <el-option v-for="it in peoplelist" :key="it.libraryIds" :label="it.libraryName" :value="it.libraryId">
            </el-option>
          </el-select>
          <el-form-item label="" prop="">
            <h-date-timerange v-model:end="tableParams.endDate" v-model:start="tableParams.startDate">
            </h-date-timerange>
          </el-form-item>
          <el-form-item label="" prop="">
            <el-button @click="setupclick" class="btn">设置</el-button>
            <el-button @click="searchbtn" class="btn">分析</el-button>
            <div class="morenBtn" @click="showMore = !showMore"></div>
          </el-form-item>
        </div>
        <div class="formDiv">
          <el-form-item label="" prop="">
            <el-select ref="selectRef" v-model="people" filterable remote reserve-keyword collapse-tags
              collapse-tags-tooltip placeholder="请输入姓名" :remote-method="changePeopleAllList" :loading="loading"
              style="width: 290px;" clearable>
              <el-option v-for="it in peopleAllList" :key="it.type" :label="it.personName + '_' + it.cardNumber"
                :value="it.cardNumber" @click="getClickPerson(it)">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="showDraggable = true">{{ selectPerson.length > 0 ? `已选择 ${selectPerson.length} 人` :
                '重点人员'
            }}
            </el-button>
            <el-button v-show="selectPerson.length>0" @click="selectPerson = [];people = ''"> 清空
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="drug-content">
      <drugControlModelLeft @emitMore=moreItemClick></drugControlModelLeft>
      <drugControlModelRight :timeData="tableParams" @changeDefaultOpen="handleLabelLegend"></drugControlModelRight>
    </div>
    <switchLabel class="drug-switch-label" v-model:open="labelLegendState" @getSwitchState="switchState"></switchLabel>
    <el-dialog v-model="clickVisible" title="规则设置" width="40%">
      <setUpDialog v-model:maybelevelrole="tableParams.startDayNum" v-model:oftenoutrole="tableParams.threshold"
        @closeDialog="clickVisible = false"></setUpDialog>
    </el-dialog>
    <draggable-dialog v-model:visible="showDraggable" :draggableData="selectPerson" :typeDialog="true" title="重点人员"
      @updateDraggable="getSelectPerson"></draggable-dialog>
    <el-dialog v-model="formVisible" :title="dialogTitle" width="73%">
      <moreDialog v-if="formVisible" ></moreDialog>
    </el-dialog>
  </div>
</template>
<script >
import {
  defineComponent,
  onMounted,
  ref,
  reactive,
  nextTick,
  watchEffect,
  toRefs,
  provide,
  toRaw
} from "vue";
import MyMap from "@/components/map/MyMap.vue";
import drugControlModelLeft from "./components/drugControlModelLeft";
import drugControlModelRight from "./components/drugControlModelRight";
import switchLabel from "./components/switchLabel";
import setUpDialog from "./components/setUpDialog.vue";
import moreDialog from "./components/moreDialog";
import { getDict } from "@/api/constant";
import { keyFaceList, oftenOutFromDeviceId } from "@/api/monitorManagement/keyControl.js";
import { basepeoplelist } from "@/api/communityCare/communityCareApi.js";
import handleCoordinates from "@/components/map/js/modular/handleCoordinates";
import moment from "moment";
export default defineComponent({
  name: "",
  components: {
    drugControlModelLeft,
    drugControlModelRight,
    setUpDialog,
    MyMap,
    switchLabel,
    moreDialog
  },
  props: {},
  setup(props) {
    const state = reactive({
      loading: false,
      showMore: false,
      showDraggable: false,
      formVisible: false,
      loaderHeatMap: true,
      dialogTitle: "",
      tableParams: {
        endDate: moment(new Date()).format("YYYY-MM-DD"),
        startDate: moment(new Date().getTime() - 1000 * 3600 * 24 * 90).format(
          "YYYY-MM-DD"
        ),
        libraryIds: 1, // 库
        type: 0, //
        regionId: 1, // 区域
        startDayNum: 0,
        threshold: 0
      },
      value: "",
      clickVisible: false,
      labelLegendState: false,
      videoPlayList: [],
      peoplelist: [],
      peopleAllList: [],
      basePeople: "",
      people: "",
      selectPerson: []
    });
    const refData = toRefs(state);
    const mapRef = ref(null);
    const selectRef = ref(null);
    const { setVideoPoint } = handleCoordinates();
    // 给子组件传值
    const ruleInfo = reactive({
      endDate: state.tableParams.endDate,
      startDate: state.tableParams.startDate,
      threshold: state.tableParams.threshold,
      startDayNum: state.tableParams.startDayNum, // 疑似离开参数
      libraryIds: state.tableParams.libraryIds, // 库
      followIds: [], // 人
      type: state.tableParams.type, // 库
      regionId: state.tableParams.regionId // 库
    });
    const getBasepeoplelist = async () => {
      const res = await basepeoplelist({
        regionId: ""
      });
      if (res.code == 0) {
        state.peoplelist = res.page.list;
        // state.tableParams.libraryIds = res.page.list[0] ? res.page.list[0].libraryId : '';
        // ruleInfo.libraryIds = res.page.list[0] ? res.page.list[0].libraryId : '';
        getoftenOutFromDeviceId();
      }
    };
    getBasepeoplelist();
    provide("ruleInfo", ruleInfo);
    watchEffect(() => {
      if (ruleInfo.endDate || ruleInfo.startDate || ruleInfo.libraryIds) {
        nextTick(() => {
          clearRegion();
          clearHeatMap();
        });
      }
    });
    const handleLabelLegend = (val) => {
      state.labelLegendState = val;
    };
    const switchState = (val) => {
      console.log(val);
      if (val.name == "分布图") {
        val.status ? createRegion(state.videoPlayList) : clearRegion();
      } else {
        state.loaderHeatMap = val.status;
        val.status ? createHeatMap(state.videoPlayList) : clearHeatMap();
      }
    };

    const changeLibraryIds = () => {
      state.selectPerson = [];
      state.peopleAllList = [];
      state.people = '';
    };
    const changeBasePeople = async (val, xm = '') => {
      const param = {
        libraryIds: val.libraryIds,
        isPage: false,
        name: xm
      };
      const res = await keyFaceList(param);
      if (res.code == 0) {
        state.peopleAllList = res.page.list;
        state.loading = false;
      }
    };
    const changePeopleAllList = (query) => {
      if (state.tableParams.libraryIds && query) {
        state.loading = true;
        changeBasePeople(state.tableParams, query);
      } else {
        state.peopleAllList = [];
      }
    };
    const getClickPerson = (item) => {
      state.selectPerson.push(item);
      state.selectPerson = state.selectPerson.filter(
        (element, index, self) => {
          element.name = element.personName + '_' + element.cardNumber;
          return (
            self.findIndex((x) => x.cardNumber === element.cardNumber) ===
            index
          );
        }
      );
    };
    const getSelectPerson = (list) => {
      state.selectPerson = list;
    };
    // 获取数据字典 调用子组件接口,频繁出没,疑似离开
    const queryMenuType = async () => {
      const res = await getDict("often_out_rule");
      const age = await getDict("maybe_level_rule");
      if (res.dict.length > 0) {
        state.tableParams.threshold = res.dict[0].value;
      }
      if (age.dict.length > 0) {
        state.tableParams.startDayNum = age.dict[0].value;
      }
    };
    // 点位数据
    const getoftenOutFromDeviceId = async () => {
      const parms = {
        ...ruleInfo,
        limit: 500
        // threshold: ruleInfo.threshold,
        // startDayNum: ruleInfo.startDayNum,
      };
      const res = await oftenOutFromDeviceId(parms);
      if (res.code == 0) {
        // res.page.list = [{
        //   libraryId: 1,
        //   libraryName: "涉黄人口",
        //   deviceId: "50015400051191000898",
        //   deviceName: "古迹街2号桥头路灯杆",
        //   countNum: 1,
        //   countPersonNum: 1,
        //   maxSnapTime: "2022-10-17T10:03:15.000+0000",
        //   longitude: "108.301821",
        //   latitude: "30.995725"
        // }];
        state.videoPlayList = res.page.list.map((item) => {
          if (item.longitude && item.latitude) {
            const coordinates = setVideoPoint([
              Number(item.longitude),
              Number(item.latitude)
            ]);
            // let coordinates = [Number(item.longitude), Number(item.latitude)];
            item.coordinates = coordinates;
            item.weight = Number(item.countNum);
            return item;
          }
        });
        nextTick(() => {
          createHeatMap(state.videoPlayList);
          // createRegion(state.videoPlayList);
        });
      }
    };

    // 创建热力图
    const createHeatMap = (list) => {
      if (state.loaderHeatMap) mapRef.value && mapRef.value.clickaddHeatmap(list);
    };
    // 清除热力图
    const clearHeatMap = () => {
      console.log("qingchu");
      mapRef.value && mapRef.value.clearHeatmap();
    };
    // 创建区域图
    const createRegion = (list) => {
      const newList = list.map((item) => {
        const pointInfo = {
          name: item.deviceName,
          id: item.deviceId,
          type: 1,
          // poiType: ,
          showType: 2,
          location: toRaw(item.coordinates),
          click: (e) => { }
        };
        return pointInfo;
      });
      console.log(newList);
      mapRef.value && mapRef.value.loadMarker(newList);
    };
    // 清除区域图
    const clearRegion = (list) => {
      mapRef.value && mapRef.value.clearPoint();
    };
    const searchbtn = () => {
      for (const key in ruleInfo) {
        ruleInfo[key] = state.tableParams[key];
      };
      ruleInfo.followIds = state.selectPerson.map((item) => {
        return item.cardNumber;
      });
      clearHeatMap();
      getoftenOutFromDeviceId();
      console.log(ruleInfo);
    };
    const setupclick = () => {
      state.clickVisible = true;
    };
    const moreItemClick = (text) => {
      state.formVisible = true;
      state.dialogTitle = text;
    };
    queryMenuType();

    onMounted(() => { });
    return {
      ...refData,
      mapRef,
      selectRef,
      searchbtn,
      setupclick,
      handleLabelLegend,
      switchState,
      getBasepeoplelist,
      changePeopleAllList,
      getClickPerson,
      getSelectPerson,
      moreItemClick,
      changeLibraryIds
    };
  }
});
</script>
<style  lang='scss' scoped >
.drugControlModel {
  height: 100%;
  width: 100%;
  position: relative;

  .my-map-box {
    position: relative;
    height: 100%;
    width: 100%;
    z-index: 1;
  }

  .selectarea {
    border-radius: 8px;
    background-color: rgba(77, 99, 133, 1);
    background-repeat: no-repeat;

    position: absolute;
    top: 50px;
    left: 50%;
    transform: translate(-50%);
    overflow: hidden;
    // display: flex;
    // align-items: center;
    // justify-content: space-between;
    z-index: 2;
    padding: 10px;
    box-sizing: border-box;
    height: 56px;

    &.more {
      animation: changeHeight 0.5s;
      animation-fill-mode: both;
    }

    .formDiv {
      height: 46px;

      .morenBtn {
        width: 18px;
        height: 12px;
        margin-left: 7px;
        background: url("~@/assets/images/home/xiala.png") no-repeat;
        background-size: 100% 100%;
      }
    }

    ::v-deep .el-select {
      margin-right: 15px !important;
    }

    .selectareaitme {
      z-index: 5;
    }

    ::v-deep .el-input__inner {
      background-color: #065080 !important;
      outline: none !important;
      border: none !important;

      input {
        background-color: #065080 !important;
      }
    }
  }

  // .form-inline {
  :deep(.el-input__inner) {
    background-color: transparent !important;
    color: #fff;
    font-size: 16px;
  }

  // }

  .drug-content {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3;
    pointer-events: none;
    display: flex;

    .drug-left {
      pointer-events: auto;
    }
  }

  :deep(.el-date-editor .el-range-input) {
    // background-color: transparent;
    color: #fff;
    font-size: 16px;
  }

  :deep(.el-input-group__append) {
    background-color: transparent;
    color: #fff;
    font-size: 16px;
  }

  :deep(.el-form-item) {
    margin-bottom: 0;
  }

  :deep(input) {
    background-color: rgba(6, 80, 128, 0.1) !important;
    color: #fff;
  }

  @keyframes changeHeight {
    0% {
      height: 52px;
    }

    100% {
      height: 100px;
    }
  }
}
</style>